export const SYSTEMS = [
  {
    slug: "pvra",
    path: "/pvra",
    code: "01",
    name: "PVRA",
    subtitle: "PINE Virtual Reality Arena",
    short:
      "Das große Virtual-Reality-Arena-System für größere Freizeitflächen und professionelle Betreiberstrukturen.",
    cta: "PVRA ansehen",
    image:
      "https://static.prod-images.emergentagent.com/jobs/e0a0edc5-a8be-487a-84fc-fda23ce4e3e5/images/b5c5e47aed0193510a4f69a97e93396752f6048fdbb4df0765ea0a056d093a2f.png",
  },
  {
    slug: "ar-ena",
    path: "/ar-ena",
    code: "02",
    name: "AR_ENA",
    subtitle: "Augmented Reality Arena",
    short:
      "Action, Bewegung und Competition mit System für sportlich-kompetitive Gruppenerlebnisse.",
    cta: "AR_ENA ansehen",
    image: "https://images.pexels.com/photos/36545253/pexels-photo-36545253.jpeg",
  },
  {
    slug: "pine-vr",
    path: "/pine-vr",
    code: "03",
    name: "PINE VR",
    subtitle: "PINE Virtual Reality",
    short:
      "Das kompakte professionelle VR-Standortprodukt für kleinere Flächen, Eventlocations und bestehende Freizeitbetriebe.",
    cta: "PINE VR ansehen",
    image:
      "https://static.prod-images.emergentagent.com/jobs/e0a0edc5-a8be-487a-84fc-fda23ce4e3e5/images/16a9afd3329e15316f815357e619ae306e33d9b6c6ca7e1c521579678be971bb.png",
  },
  {
    slug: "hotel-vr",
    path: "/hotel-vr",
    code: "04",
    name: "Hotel VR",
    subtitle: "Inhouse Gäste Entertainment",
    short:
      "Das Inhouse-Erlebnis für Hotels, Resorts und touristische Betriebe. Für mehr Aufenthaltsqualität, Schlechtwetterangebote und moderne Gästeerlebnisse.",
    cta: "Hotel VR ansehen",
    image:
      "https://static.prod-images.emergentagent.com/jobs/e0a0edc5-a8be-487a-84fc-fda23ce4e3e5/images/26ef17aaf7a817b0c239e7a67375489c6afab8c7d6735a5429370222696c079c.png",
  },
  {
    slug: "pine-places",
    path: "/pine-places",
    code: "05",
    name: "PINE Places",
    subtitle: "A Customer Journey",
    short:
      "Reale Orte als digitale Markenräume zur Steuerung der Markenwahrnehmung und digitalen Präsenz.",
    formula: "Dein Place + PINE Places = Dein Markenraum.",
    cta: "PINE Places ansehen",
    image:
      "https://images.unsplash.com/photo-1767462315183-0feb9ab9f3f6",
  },
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/e0a0edc5-a8be-487a-84fc-fda23ce4e3e5/images/f5e903cfe84be37fb54e4e6acb94a05b00d662f6dcbac4ab03476220b2580a8f.png";

export const LEAD_STATUSES = [
  { value: "new_lead", label: "Neuer Lead" },
  { value: "founder_without_location", label: "Gründer ohne Fläche" },
  { value: "Standortdaten_erhalten", label: "Standortdaten erhalten" },
  { value: "Erstgespraech_ausstehend", label: "Erstgespräch ausstehend" },
  { value: "Erstgespraech_gebucht", label: "Erstgespräch gebucht" },
  { value: "Produktfit_offen", label: "Produktfit offen" },
  { value: "Standortpruefung_erforderlich", label: "Standortprüfung erforderlich" },
  { value: "qualified", label: "Qualifiziert" },
  { value: "not_fit", label: "Nicht passend" },
];
